import CollectionDetailPage from '../CollectionDetailPage';
export default function HomeOfficePage() { return <CollectionDetailPage collectionId="home-office" />; }
